export enum SizeCategoryEnum {
    Size_One ="Size 1",
    Size_Two = "Size 2",
    Size_Three = "Size 3"
}